import { createContext } from 'use-context-selector'
import { type PropsWithChildren, useEffect, useState } from 'react'

export interface NetworkType {
  isOnline: boolean
}
export const Network = createContext<NetworkType>({
  isOnline: false
})

export const NetworkProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
    }
    const handleOffline = () => {
      setIsOnline(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return (
        <Network.Provider
            value={{ isOnline }}
        >
            {children}
        </Network.Provider>
  )
}
